// extracted by mini-css-extract-plugin
module.exports = {"companyContainer":"partners_companyContainer__14BU9"};